// extracted by mini-css-extract-plugin
export default {"detail":"KlRpjmL6","adm-list-item":"YXmcjILI"};